export default __webpack_public_path__ + "static/media/Všeobecné Obchodní Podmínky platné od 1.6.2021 - Prague Depot Malešice.953ddad7.pdf";